export default __webpack_public_path__ + "static/media/InfoSession.70825678.png";